import { useApi, createApiHook } from "../utils/apiUtils";

const useToggleUserActive = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const toggleUserActive = async ({ userId, activate }) => {
    startLoading();
    const response = await apiPatch(`/users/${userId}/toggle_active`, "Error al activar o desactivar el usuario", { activate });
    setResponse(response);

    return !response?.error;
  };

  return { toggleUserActive, data, error, loading };
};

export default useToggleUserActive;
